import { KazMon } from '@ds/logging';
import { configuration } from 'services';

const KazMonEventConstants = {
    applicationMonitoringName: 'ClaimProvider.Verify.Front',
    defaultEventName: 'Client Telemetry',
    defaultEventType: 'DocuSign.Monitoring.ClientTelemetry',
};

class MonitoringService {
    private kazMonInstance!: KazMon;
    private kazMonClientVariables!: {
        SessionId: string;
        DisplayLanguage: string | null;
    };

    get kazMon(): KazMon {
        return this.kazMonInstance;
    }

    private set kazMon(_kazMonInstance: KazMon) {
        this.kazMonInstance = _kazMonInstance;
    }

    public isKazmonInitialized(): boolean {
        return this.kazMon !== undefined;
    }

    public initialize = (language: string | undefined): void => {
        if (!this.isKazmonInitialized()) {
            this.initializeKazMon(language === undefined ? null : language);
        }
    }

    private initializeKazMon(language: string | null): void {
        this.kazMon = new KazMon({
            application: KazMonEventConstants.applicationMonitoringName,
            environment: configuration.environmentName(),
            endpointUrl: configuration.kazmonEndpointUrl(),
            instrumentationKey: configuration.kazmonInstrumentationKey(),
        });
        this.kazMon.setAppVersion(configuration.buildVersion());
        this.kazMonClientVariables = {
            SessionId: configuration.sessionId(),
            DisplayLanguage: language,
        };
    }

    public emitEvent(eventName: string, data: Record<string, unknown>): void {
        if (false === this.isKazmonInitialized()) {
            return;
        }

        this.kazMon.emitEvent(
            {
                eventCategory: KazMonEventConstants.applicationMonitoringName,
                eventName: KazMonEventConstants.defaultEventName,
                eventType: KazMonEventConstants.defaultEventType,
            },
            {
                DataPoints: {
                    ...this.kazMonClientVariables,
                    ...data,
                    Event: eventName,
                    Timestamp: new Date(),
                },
            },
        );
    }
}

export let monitoring = new MonitoringService();
